import * as React from 'react';
import { FormControlProps } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import './SearchInput.css';

export interface SearchInputProps extends FormControlProps {
    /** Material-UI Icon for left of search */
    leftIcon?: string;
    /** Material-UI Icon for right of search */
    rightIcon?: string;
    /** Custom style object for search input wrapper */
    wrapperStyles?: any;
    /** Custom class for search input wrapper */
    wrapperClassName?: string;
    onClick?: any;
}

const SearchInput: React.FC<SearchInputProps> = (props: SearchInputProps) => {
    const { rightIcon, leftIcon, wrapperStyles, wrapperClassName } = props;
    const inputProps = (({ leftIcon, rightIcon, wrapperStyles, wrapperClassName, ...p }) => p)(props);

    const handleClear = (e: React.MouseEvent) => {
        e.preventDefault();
        //@ts-ignore
        inputProps?.onChange({ target: { value: "", name: inputProps.name }, preventDefault: () => null })
    }

    return (
        <InputGroup style={wrapperStyles} className={`search-input ${wrapperClassName}`}>
            <InputGroup.Prepend>
            {
                inputProps.value
                ?<InputGroup.Text onClick={handleClear} className="material-icons">close</InputGroup.Text>
                :<InputGroup.Text className="material-icons">{leftIcon}</InputGroup.Text>
            }
            </InputGroup.Prepend>
            <Form.Control {...inputProps}/>
            {
                rightIcon &&
                <InputGroup.Append>
                    <InputGroup.Text className="material-icons">{props.rightIcon}</InputGroup.Text>
                </InputGroup.Append>
            }
        </InputGroup>
    );
}

SearchInput.defaultProps = {
    leftIcon: "search",
    wrapperStyles: {},
    wrapperClassName: ""
}

export default SearchInput;